import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { CartProvider } from './CartContext';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Login from './screens/Login';
import AboutUs from './screens/AboutUs/AboutUs';
import Services from './screens/ServicesInterface/Services';
import ServicesStagiaires from './screens/ServicesStagiaires/ServicesStagiaires';
import Contact from './screens/Contact/Contact';
import Products from './screens/Product/Products';
import Home from './screens/Home/Home';
import ProductDetail from './screens/Product/ProductDetail';
import Cart from './screens/Product/Cart';
import Checkout from './screens/Product/Checkout';
import Register from './screens/Register';
import AttestationForm from './screens/Product/AttestationForm';
import ResetPassword from './screens/ResetPassword';
import ForgetPassword from './screens/ForgetPassword';
import './App.css';


import AdminDashboard from './screens/Admindashboard';
function App() {
  return (
    <AuthProvider> 
      <Router>
        <CartProvider>
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/about" element={<AboutUs />} />
                <Route path="/services" element={<Services />} />
                <Route path="/ServicesStagiaires" element={<ServicesStagiaires />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/products" element={<Products />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/attestation" element={<AttestationForm />} />
                
                <Route path="/forgot-password" element={<ForgetPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />


                <Route path="/" element={<Home />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </CartProvider>
      </Router>
    </AuthProvider>  
  );
}

export default App;